import OrganisationOverview from './OrganisationOverview'
import enhance from './OrganisationOverview.enhancer'

export default enhance(OrganisationOverview)



// WEBPACK FOOTER //
// ./src/containers/organisation/OrganisationOverview/index.js